import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=43412ace&"
import script from "./ProductGroup.vue?vue&type=script&lang=js&"
export * from "./ProductGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43412ace')) {
      api.createRecord('43412ace', component.options)
    } else {
      api.reload('43412ace', component.options)
    }
    module.hot.accept("./ProductGroup.vue?vue&type=template&id=43412ace&", function () {
      api.rerender('43412ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-group/ProductGroup.vue"
export default component.exports